import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Button } from "@carbon/react";
import { JointOrderOfferStatusResponse } from "../../types";
import "./bid.scss";

export type JointPendingOffersProps = {
  jointOfferStatus?: JointOrderOfferStatusResponse | null;
  multipleOrderId: string | null;
};

/**
 * The joint seller view's "products still without an offer" panel (Task 6) — lists the lines the
 * supplier has not yet quoted in this joint RFQ, with a shortcut to quote the first one. Only
 * rendered by `JointSellerOffer.tsx` while the order is open and some lines remain.
 */
const JointPendingOffers = ({
  jointOfferStatus,
  multipleOrderId,
}: JointPendingOffersProps) => {
  const { t } = useTranslation();
  const pending = jointOfferStatus?.ordersWithoutOffers ?? [];

  return (
    <div className="seller-offer__pending">
      <div>
        <h4>{t("offer.productsWithoutOffer")}</h4>
        <p>
          {pending.length} {t("offer.productsRemaining")}
        </p>
      </div>
      <Button
        kind="tertiary"
        size="sm"
        as={Link}
        to={`/orders/multiple/${pending[0]?.orderId}?multipleOrderId=${multipleOrderId}`}
      >
        {t("offer.offerOnRemaining")}
      </Button>
    </div>
  );
};

export default JointPendingOffers;
